<template>
  <div class="main-wrapper">
    <import-task ref="importTask">
      <template slot="header">
        <search-box class="search-box">
          <el-form :inline="true" size="mini">
            <el-form-item label="日期">
              <form-date-range :form="form" startKey="startDate" :usingTime="false" endKey="endDateStr" valueFormat="yyyy-MM-dd HH:mm:ss"></form-date-range>
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button type="primary" size="small" @click="handleSearch">搜索</el-button>
          </template>
        </search-box>
      </template>
      <template slot="main-header">
        <el-button
          type="primary"
          size="mini"
          @click="showExport"
        >批量导入
        </el-button>
      </template>
    </import-task>
    <el-dialog :title="titleName" width="60%;" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <div slot="footer" class="dialog-footer">
        <el-form :model="requestParam" :rules="rules" ref="requestParam" :inline="true">
          <el-row>
            <el-col :span="24" align="left">
              <el-form-item label="附件" prop="goodsCode" label-width="40px">
                <el-upload
                  class="upload-demo"
                  ref="upload"
                  accept=".xls,.xlsx,.xls.ttt,.xlsx.ttt"
                  :limit="1"
                  action=""
                  :http-request="httpRequest"
                  :on-remove="handleRemove"
                  :headers="headers"
                  :file-list="fileList"
                  :on-success="handleSuccess"
                  :before-upload="beforeUpload"
                >
                  <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                  <el-button style="margin-left: 10px;"
                             v-loading.fullscreen.lock="fjLoading"
                             element-loading-text="数据导入中"
                             element-loading-spinner="el-icon-loading"
                             element-loading-background="rgba(0, 0, 0, 0.8)"
                             size="small" type="success" @click="submitUpload">上传
                  </el-button>
                  <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且只能上传一个</div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-button @click="cancel" size="medium">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getToken} from '@/utils/auth'
import moment from 'moment'
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  mixins: [pagePathMixin],
  data() {
    return {
      form: {
        startDate: '',
        endDate: '',
        endDateStr:'',
        reportName: ''
      },
      dialogFormVisible: false,
      titleName: '',
      requestParam: {},
      headers: {
        'Authorization': getToken()
      },
      fileList: [],
      rules: {},
      fjLoading: false
    }
  },
  computed: {
    pageObj() {

      const type = this.$route.params.type;
      let obj = {};
      switch(type) {
        case 'newProductAdd':
          obj['name'] = '产品基础信息导入';
          obj['reportName'] = 'newProductBasicAttrImport';
        break;



        // lyl修改部分
        case 'competeStoreDataImport':
          obj['name'] = '竞店数据竞争店铺导入';
          obj['reportName'] = 'competeStoreDataImport';
        break;
        case 'industryCategoryDataImport':
          obj['name'] = '竞店数据行业类目导入';
          obj['reportName'] = 'industryCategoryDataImport';
        break;
        case 'flowSourceDataImport':
          obj['name'] = '竞店数据流量来源导入';
          obj['reportName'] = 'flowSourceDataImport';
        break;
        case 'packClearanceDataImport':
          obj['name'] = '包件清仓信息维护导入';
          obj['reportName'] = 'packClearanceDataImport';
        break;
        case 'productPriceCoefficientImport':
          obj['name'] = '产品价格系数维护导入';
          obj['reportName'] = 'productPriceCoefficientImport';
        break;
        case 'productRetailPriceDataImport':
          obj['name'] = '产品基础价格维护导入';
          obj['reportName'] = 'productRetailPriceDataImport';
        break;
        case 'productClearPriceDataImport':
          obj['name'] = '清仓销售价系数维护导入';
          obj['reportName'] = 'productClearPriceDataImport';
        break;
        case 'goodsSalesPriceDataImport':
          obj['name'] = '商品销售价导入';
          obj['reportName'] = 'goodsSalesPriceDataImport';
        break;
         case 'goodsPriceCoefficientImport':
          obj['name'] = '商品价格系数导入';
          obj['reportName'] = 'goodsPriceCoefficientImport';
        break;
         case 'goodsBaseAttrImport':
          obj['name'] = '商品基础属性导入';
          obj['reportName'] = 'goodsBaseAttrImport';
        break;
        case 'goodsDeliveryCycleImport':
          obj['name'] = '商品发货周期导入';
          obj['reportName'] = 'goodsDeliveryCycleImport';
        break;
        case 'spuImport':
          obj['name'] = 'spu导入';
          obj['reportName'] = 'spuImport';
        break;
        case 'preSalePlanPackDataImport':
          obj['name'] = '预销计划包件信息导入';
          obj['reportName'] = 'preSalePlanPackDataImport';
        break;
        case 'preSalePlanGoodsDataImport':
          obj['name'] = '预销计划商品信息导入';
          obj['reportName'] = 'preSalePlanGoodsDataImport';
        break;

        // lyl修改部分


        case 'newProductShootBatch':
          obj['name'] = '拍摄批次导入';
          obj['reportName'] = 'newProductShootBatchImport';
        break;
        case 'newProductModifyStatus':
          obj['name'] = '流程节点批量导入';
          obj['reportName'] = 'newProductTime2RemarkTiImport';
        break;
        case 'newProductAddTime2Remark':
          obj['name'] = '上新时间和备注导入';
          obj['reportName'] = 'putAwayTiForTaskStatusImport';
        break;
        case 'sevendaysDeliveryArea':
          obj['name'] = '7天发货区域';
          obj['reportName'] = 'sevenDayDeliveryAreaImport';
        break;
        case 'outofstockReply':
          obj['name'] = '缺货回复';
          obj['reportName'] = 'planDeptReplyDataImport';
        break;
        case 'deliveryTime':
          obj['name'] = '出货时间';
          obj['reportName'] = 'orderGoodsShipmentDataImport';
        break;
        case 'salesTarget':
          obj['name'] = '销售目标';
          obj['reportName'] = 'salesTargetDataImport';
        break;
        case 'productingPackageStatus':
          obj['name'] = '包件在产状态';
          obj['reportName'] = 'packStatusDataImport';
        break;
        case 'secondaryIndustry':
          obj['name'] = '行业二级';
          obj['reportName'] = 'competeIndustryLevel2InfoDataImport';
        break;
        case 'tertiaryIndustry':
          obj['name'] = '行业三级';
          obj['reportName'] = 'competeIndustryLevel3InfoDataImport';
        break;
        case 'raceShopContrast':
          obj['name'] = '竞店对比';
          obj['reportName'] = 'competeStoreComparisonDataImport';
        break;
        case 'competingStoreLoss':
          obj['name'] = '竞店流失';
          obj['reportName'] = 'competeLeaveInfoDataImport';
        break;
        case 'shopCampaigns':
          obj['name'] = '竞店推广';
          obj['reportName'] = 'competeStoreExtensionDataImport';
        break;
        case 'whiteList':
          obj['name'] = '白名单';
          obj['reportName'] = 'whiteListImport';
        break;
         case 'jdWoodGoodsImport':
          obj['name'] = '实木商品导入';
          obj['reportName'] = 'jdWoodGoodsImport';
        break;
      }
      return obj;
    },

  },
  methods: {
    handleSearch() {
      console.log(this.$refs['importTask'].propList);
      this.form.endDate = this.form.endDateStr==null || this.form.endDateStr=='' ? this.form.endDateStr : (this.form.endDateStr.substr(0,10) + ' 23:59:59');
      this.$refs['importTask'].init(this.form);
    },
    showExport() {
      this.fileList = [];
      this.dialogFormVisible = true;
      let filename = this.$route.query.fileName;
      filename = filename.substring(0, filename.lastIndexOf('.'))
      this.titleName = filename + '批量维护';
    },
    cancel() {
      this.dialogFormVisible = false;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      console.log(file, fileList);
    },
    httpRequest(file) {

    },
    handleSuccess(res, file) {
      if (res.code === 200) {
        this.$message.success(res.message);
      } else {
        this.$message.error(res.message);
      }
      this.cancel();
      this.handleSearch();
    },
    // 验证
    beforeUpload(file) {
      // .xls,.xlsx,.xls.ttt,.xlsx.ttt
      let pattern = file.name.substring(file.name.lastIndexOf('.') + 1);
      if (['xls', 'xlsx', 'xls.ttt', 'xlsx.ttt'].indexOf(pattern.toLowerCase()) === -1) {
        this.$message.error('请上传后缀名为.xls,.xlsx的附件！');
        return false;
      }
      this.fileList = [];
      this.fileList.push(file);
    },
    submitUpload(file) {
      if (!this.fileList || this.fileList.length === 0) {
        this.$message.error('请先上传Excel附件');
        return;
      }
      this.fjLoading = true;
      let taskDTO=null;
      if(this.form.reportName==='preSalePlanGoodsDataImport' || this.form.reportName==='preSalePlanPackDataImport'){
        let storeId = this.$route.query.storeId;
        let planTime = this.$route.query.planTime;
        let fields = [
          {
            columnName: "店铺",
            columnValue: sessionStorage.getItem('storeName'),
            fieldName: "storeId",
            fieldValue: storeId,
            relation: "storeId"
          }, {
            columnName: "提报日期",
            columnValue: planTime,
            fieldName: "planTime",
            fieldValue: planTime,
            relation: "planTime"
          }
        ];
        taskDTO = {
          reportName: this.form.reportName,
          appCode: "ec-pc-new",
          paramMap: fields//预销计划
        };
      }else{
        taskDTO = {
          reportName: this.form.reportName,
          appCode: "ec-pc-new"
        };
      }

      this.$q.common.uploadFile({
        data: {
          file: this.fileList[0],
          taskDTO: JSON.stringify(taskDTO)
        }
      }).then((res) => {
        if (res.success) {
          this.$message.success('数据导入中，请稍后');
        } else {
          this.$message.error(res.message);
        }
        this.fjLoading = false;
        this.cancel();
        this.handleSearch();
      });
      // this.$refs.upload.submit();
    },
  },
  created() {
    document.title = this.pageObj.name;
  },
  mounted() {
    console.log(this.$route.params);
    this.form.reportName = this.pageObj.reportName;
    this.handleSearch();

    // 设置tagsView页面标签名称
    setTimeout(_=>{
      this.$store.dispatch('tagsView/updateVisitedView', {
        ...this.$route,
        title: this.pageObj.name,
        meta: {
          title: this.pageObj.name
        }
      })
    },300)
  }
}
</script>

<style lang="stylus" scoped>
.main-wrapper
  height calc(100vh - 65px)
.root
  padding 5px
>>> .el-header
  height: 39px !important
  margin-bottom: 5px
  padding 0
</style>
